// API Configuration
// This will automatically switch between local and production based on environment

const getApiUrl = () => {
  // Check if we're in production (deployed)
  if (process.env.NODE_ENV === "production") {
    // Use production API URL from environment variable or default
    return (
      process.env.REACT_APP_API_URL ||
      "https://api.booktrivana.com/api"
    );
  }
  // Use local development URL
  return process.env.REACT_APP_API_URL || "https://api.booktrivana.com/api";
};

export const API_CONFIG = {
  BASE_URL: getApiUrl(),
  AUTH_URL: `${getApiUrl()}/auth`,
  BOOKING_URL: `${getApiUrl()}/bookings`,
  HOTEL_URL: `${getApiUrl()}/hotels`,
  RESTAURANT_URL: `${getApiUrl()}/restaurants`,
  PROFILE_URL: `${getApiUrl()}/profile`,
  BLOG_URL: `${getApiUrl()}/blog`,
};

// Export individual URLs for convenience
export const BASE_URL = API_CONFIG.BASE_URL;
export const AUTH_URL = API_CONFIG.AUTH_URL;

export default API_CONFIG;
